module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar maxWidth = 250;\nvar resourceAttributes = (resourceData || {}).attributes || {}\nvar stats = resourceAttributes.stats || {}\nvar width, barWidths = {};\nvar widthSum = 0;\nvar nrOfAll = stats.all || 1;\nvar nrOfSent = stats.processed || 0;\nvar nrOfReceived = stats.sent || 0;\nvar nrOfUndeliverables = stats.hardBounce || 0;\n// softBounces will be treated as sent but not received until the mailing sendStatus is \"finished\"\nif (resourceAttributes.sendStatus === 'finished') {\nnrOfUndeliverables += (stats.softBounce || 0);\n} else {\nnrOfSent += (stats.softBounce || 0);\n}\nvar nrOfOther = nrOfAll - nrOfSent - nrOfReceived - nrOfUndeliverables;\nif(nrOfOther > 0){\nwidth = Math.round(nrOfOther / nrOfAll * maxWidth);\nif(width > 0){\nbarWidths.other = {\nwidth: width,\nnrOfElements: nrOfOther\n};\nwidthSum += width;\n}\n}\nif(nrOfSent > 0){\nwidth = Math.round(nrOfSent / nrOfAll * maxWidth);\nif(width > 0){\nbarWidths.sent = {\nwidth: width,\nnrOfElements: nrOfSent\n};\nwidthSum += width;\n}\n}\nif(nrOfReceived > 0){\nwidth = Math.round(nrOfReceived / nrOfAll * maxWidth);\nif(width > 0){\nbarWidths.received = {\nwidth: width,\nnrOfElements: nrOfReceived\n};\nwidthSum += width;\n}\n}\nif(nrOfUndeliverables > 0){\nwidth = Math.round(nrOfUndeliverables / nrOfAll * maxWidth);\nif(width > 0){\nbarWidths.undeliverable = {\nwidth: width,\nnrOfElements: nrOfUndeliverables\n};\nwidthSum += width;\n}\n}\nif (widthSum < 250) {\nvar usedStatus = Object.keys(barWidths);\nif(usedStatus.length > 0){\nbarWidths[usedStatus.pop()].width += maxWidth - widthSum;\n}\n}\n%>\n<div data-all=\"<%- nrOfAll %>\">\n<%\nfor(var status in barWidths){\n%><div class=\"bar <%- status %>\" style=\"width: <%= barWidths[status].width %>px\" data-elements=\"<%- barWidths[status].nrOfElements %>\"></div><%\n}\n%>\n</div>"
  , __filename = "components/templates/newsletter/mailings/table/fields/sendStatusChart.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var maxWidth = 250;
var resourceAttributes = (resourceData || {}).attributes || {}
var stats = resourceAttributes.stats || {}
var width, barWidths = {};
var widthSum = 0;
var nrOfAll = stats.all || 1;
var nrOfSent = stats.processed || 0;
var nrOfReceived = stats.sent || 0;
var nrOfUndeliverables = stats.hardBounce || 0;
// softBounces will be treated as sent but not received until the mailing sendStatus is "finished"
if (resourceAttributes.sendStatus === 'finished') {
nrOfUndeliverables += (stats.softBounce || 0);
} else {
nrOfSent += (stats.softBounce || 0);
}
var nrOfOther = nrOfAll - nrOfSent - nrOfReceived - nrOfUndeliverables;
if(nrOfOther > 0){
width = Math.round(nrOfOther / nrOfAll * maxWidth);
if(width > 0){
barWidths.other = {
width: width,
nrOfElements: nrOfOther
};
widthSum += width;
}
}
if(nrOfSent > 0){
width = Math.round(nrOfSent / nrOfAll * maxWidth);
if(width > 0){
barWidths.sent = {
width: width,
nrOfElements: nrOfSent
};
widthSum += width;
}
}
if(nrOfReceived > 0){
width = Math.round(nrOfReceived / nrOfAll * maxWidth);
if(width > 0){
barWidths.received = {
width: width,
nrOfElements: nrOfReceived
};
widthSum += width;
}
}
if(nrOfUndeliverables > 0){
width = Math.round(nrOfUndeliverables / nrOfAll * maxWidth);
if(width > 0){
barWidths.undeliverable = {
width: width,
nrOfElements: nrOfUndeliverables
};
widthSum += width;
}
}
if (widthSum < 250) {
var usedStatus = Object.keys(barWidths);
if(usedStatus.length > 0){
barWidths[usedStatus.pop()].width += maxWidth - widthSum;
}
}

    ; __line = 64
    ; __append("\n<div data-all=\"")
    ; __line = 65
    ; __append( nrOfAll )
    ; __append("\">\n")
    ; __line = 66
    ; 
for(var status in barWidths){

    ; __line = 68
    ; __append("<div class=\"bar ")
    ; __append( status )
    ; __append("\" style=\"width: ")
    ; __append(escapeFn( barWidths[status].width ))
    ; __append("px\" data-elements=\"")
    ; __append( barWidths[status].nrOfElements )
    ; __append("\"></div>")
    ; 
}

    ; __line = 70
    ; __append("\n</div>")
    ; __line = 71
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/newsletter/mailings/table/fields/sendStatusChart.ejs

}